import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from "../actions/notification";

const initialState = {
  visible: false,
  type: null,
  message: "",
  description: "",
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        ...state,
        visible: true,
        ...action.payload,
      };
    case HIDE_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};

export default notificationReducer;
